import { DateHelper } from "../../../../Common/DateHelper";
import { IMenuItems } from "../../../../Providers.Api/CateringMenus/CateringMenuRepository";
import { ODataSelect } from "../../../../Providers.Api/ODataQuery";

export class CateringMenu extends ODataSelect {
    public Menu_Id = '';
    public Node_Id = 0;
    public Name = '';
    public Description = '';
    public Short_Description = '';
    public ImageURI = '';
    public Status = '';
    public Available_From = DateHelper.null();
    public Available_Until = DateHelper.null();
    public ConcurrencyStamp = '';
    public CreatedByUserId = '';
    public ModifiedByUserId = '';
    public OwnedByUserId = '';
    public Menu_MenuItems: IMenuItems[] = [];
    public Menu_Roles= [];
    public Menu_Spaces= [];

    public init(response: any, nodeId: number): CateringMenu {
        super.init(response, nodeId);
        
        this.Available_From = DateHelper.fromIsoByNode(response.Available_From, nodeId);
        this.Available_Until = DateHelper.fromIsoByNode(response.Available_Until, nodeId);
        
        return this;
    }
}
